// extracted by css-extract-rspack-plugin
export default {"cls1":"CourseResults-cls1_yMY","cls2":"CourseResults-cls2_hs0 CourseResults-cls1_yMY"};